import { create } from "zustand";

interface IdefaultValues {
  id: number | string;
  onClick: () => void;
  title?: string;
  description?: string;
  confirmLabel?: string;
}

const defaultValues = {
  id: "",
  onClick: () => {},
  title: "",
  description: "",
  confirmLabel: "",
};

interface IuseSuretyModel {
  onOpenSuretyPopup: ({ id }: IdefaultValues) => void;
  onCloseSuretyPopup: () => void;
  initialValues: IdefaultValues;
}

export const useSuretyModel = create<IuseSuretyModel>((set) => ({
  initialValues: defaultValues,
  onOpenSuretyPopup: ({
    id,
    onClick,
    title,
    description,
    confirmLabel,
  }: IdefaultValues) =>
    set({
      initialValues: { id, onClick, title, description, confirmLabel },
    }),
  onCloseSuretyPopup: () =>
    set({
      initialValues: defaultValues,
    }),
}));
